export default function replaceLast(source, what, replacement) {
  if (!source) {
    return;
  }
  if (!source.includes(what)) {
    return source;
  }
  var pcs = source.split(what);
  var lastPc = pcs.pop();
  return pcs.join(what) + replacement + lastPc;
}
